import React, {Fragment, useRef, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import Loading from "../Loading/Loading";
import LoadingText from "../Loading/LoadingText";
import {useSelector} from "react-redux";
import appUtility from "../../RestAPI/AppUtility";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";


export default function PendingTask(){
    let state=useSelector((state)=> state);
    const ref=useRef();

    const [DivisionTask, setDivisionTask]=useState([]);
    const [CircleTask, setCircleTask]=useState([]);
    const [DataTask, setDataTask]=useState([]);
    const [ColumnTask, setColumnTask]=useState([{}]);

    const [DataLengthTask, setDatalengthTask]=useState(0);
    const [IdTask, setIdTask]=useState();
    const [BinTask, setBinTask]=useState();

    const[DataStatusTask, setDataStatusTask]=useState(false);


    const [ShowTask, setShowTask] = useState(false);
    const handleCloseTask = () => setShowTask(false);
    const handleShowTask = () => setShowTask(true);


    const selectRow={
        mode:'radio',
        onSelect:(row,isSelect,rowIndex)=>{
            setIdTask(row['Id']);
            setBinTask(row['BIN']);
            handleShowTask();
        }
    }
    const getBIN=()=>{
        setDataStatusTask(true);
        setDatalengthTask(0)

        const Commi=document.getElementById("cmbCommiTask");
        const CommiValue=Commi.options[Commi.selectedIndex].text;

        const DivisionTask=document.getElementById("cmbDivisionTask");
        const DivisionValueTask=DivisionTask.options[DivisionTask.selectedIndex].text;

        const CircleTask=document.getElementById("cmbCircleTask");
        const CircleValueTask=CircleTask.options[CircleTask.selectedIndex].text;

        const RangeTask=document.getElementById("cmbRangeTask");
        const RangeValueTask=RangeTask.options[RangeTask.selectedIndex].text;

        const OfficerTask=document.getElementById("txtOfficerTask").value;

        const TaskStatus=document.getElementById("cmbStatusTask");
        const TaskStatusValue=TaskStatus.options[TaskStatus.selectedIndex].text;

        const TitleTask=document.getElementById("cmbTitleTask");
        const TitleTaskValue=TitleTask.options[TitleTask.selectedIndex].text;

        const DataLimitTask=document.getElementById("cmbDataLimitTask");
        const DataLimitValueTask=DataLimitTask.options[DataLimitTask.selectedIndex].text;

        let getCommiTask=" ";
        let getDivisionTask=" ";
        let getCircleTask=" ";
        let getRangeTask="";
        let getStatusTask="" ;
        let getOfficerTask="" ;

        let getStatusTaskTitle="" ;
        let getlimitTask ="";

        let jsonObject;



        if(state.accessCom=="NBR")
        {if(Commi.selectedIndex!=0){getCommiTask="And Commissionerate Like '%"+CommiValue+"%'"}}
        else{getCommiTask="And Commissionerate Like '%"+state.accessCom+"%'"}

        if(state.accessDiv=="All Division"){if(DivisionTask.selectedIndex!=0){getDivisionTask="And Division Like '%"+DivisionValueTask+"%'"}}
        else{getDivisionTask="And Division Like '%"+state.accessDiv+"%'"}

        if(state.accessCir=="All Circle"){if(CircleTask.selectedIndex!=0){getCircleTask="And Circle = '"+CircleValueTask+"'"}}
        else {getCircleTask="And Circle = '"+state.accessCir+"'"}

        if(RangeTask.selectedIndex!=0){getRangeTask="And Range_Name ='"+RangeValueTask+"'"}
        if(OfficerTask!=""){getOfficerTask="And User ='"+OfficerTask+"'"}
        if(TaskStatus.selectedIndex !=2){getStatusTask=" And Status ='"+TaskStatusValue+"' " }

        if(TitleTask.selectedIndex !=0){getStatusTaskTitle=" And Task ='"+TitleTaskValue+"' " }



        if(DataLimitTask.selectedIndex !=0){getlimitTask=" LIMIT " +DataLimitValueTask

               jsonObject={"sql":" Select Id,Circle,Range_Name,Name,BIN,Status,Task,User,DATEDIFF(CURDATE(),Start_Date ) AS Total_Days,Start_Date from Pending_Task_View where 1=1 "+getCommiTask+" "+getDivisionTask+" "+getCircleTask+" "+getRangeTask+" "+getOfficerTask+" "+getStatusTask+"  "+getStatusTaskTitle+" "+getlimitTask+" "}



        }else{getlimitTask=""

                jsonObject={"sql":" Select count(BIN)AS 'Total BIN' from Pending_Task_View  where 1=1 "+getCommiTask+" "+getDivisionTask+" "+getCircleTask+" "+getRangeTask+" "+getOfficerTask+" "+getStatusTask+" "+getStatusTaskTitle+" "}



        }

        setColumnTask([{}]);setDataTask([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{
            setDatalengthTask(result.length)
            if(result==""){cogoToast.error("Data not found");setDataStatusTask(false)}else {
                await setColumnTask(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataTask(result);
                setDataStatusTask(false)
            }
        }).catch(error=>{ setDataStatusTask(false);});
    }


    const updateTaskStatus=(status)=>{

        const TaskDoneComments=document.getElementById("txtAreaTaskDone").value;
        let jsonObject="";

        if(status==1){
            jsonObject={"sql": "Insert into bin_detailes (Id, BIN,Detailes,Entry_date,Entry_User)Values(NULL, '"+BinTask+"','"+TaskDoneComments+"','"+appUtility.getDate(new Date())+"','"+state.name+"') "};
        }else if(status==0){
            jsonObject={"sql": "Update Pending_Task set Status='Done',Finish_Comments='"+TaskDoneComments+"',Finish_Date='"+appUtility.getDate(new Date())+"',Finish_Officer='"+state.name+"' where Id='"+IdTask+"' "};

        }
        if(TaskDoneComments==""){cogoToast.error("Please insert Comments")}else {
            RestClient.PostRequest(AppUrl.updateData,jsonObject ).then(result => {
                if (result == 1) {
                    cogoToast.success("Task done saved")

                } else {
                    cogoToast.error("Task done not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
        }

    }


    return(
        <Fragment>
            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCommiTask"
                                            onChange={()=>{
                                                setDivisionTask([]);
                                                setCircleTask([]);
                                                const e = document.getElementById("cmbCommiTask");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDivisionTask(dt)


                                            }}
                                    >
                                        <option >NBR</option>
                                        {
                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbDivisionTask"
                                            onChange={()=>{
                                                setCircleTask([])
                                                const e = document.getElementById("cmbDivisionTask");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.circle.filter(x => x.Division_Id==value);
                                                setCircleTask(dt)


                                            }}
                                    >
                                        <option >All Division</option>

                                        {
                                            DivisionTask.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbCircleTask" >
                                        <option >All Circle</option>

                                        {
                                            CircleTask.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Range</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbRangeTask"  >
                                        <option >All Range</option>
                                        <option >Range-1</option>
                                        <option >Range-2</option>
                                        <option >Range-3</option>
                                        <option >Range-4</option>
                                        <option >Range-5</option>
                                        <option >Range-6</option>
                                        <option >Range-7</option>
                                        <option >No Range</option>
                                    </select>
                                </Col>

                            </Row>


                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Status</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbStatusTask"  >
                                        <option >Pending</option>
                                        <option >Done</option>
                                        <option >All</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Title</label></Col>
                                <Col lg={9}xs={8}>
                                    <select  className="float-start w-100 customfontsize" id="cmbTitleTask"  >
                                        <option>All</option>
                                        <option>Preventive</option>
                                        <option>Check Return</option>
                                        <option>Check 4.3</option>
                                        <option>Check Import</option>
                                        <option>Other</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Officer</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtOfficerTask"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbDataLimitTask"  >
                                        <option >All</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" onClick={getBIN}>Search</button>
                                </Col>


                            </Row>


                        </div>
                    </Col>

                    <Col lg={9}>

                        <div className="overflow-scroll animated zoomIn purchaseMedium2Div">
                            {
                                DataStatusTask? <LoadingText/>
                                    :<BootstrapTable ref={ref} selectRow={selectRow} id="BinTable" keyField='Id' data={DataTask} columns={ColumnTask}></BootstrapTable>


                            }
                        </div>
                        <di>
                            <label className="text-danger">Data found: {DataLengthTask}</label>

                        </di>

                    </Col>


                </Row>


            </div>



            <Modal show={ShowTask} onHide={handleCloseTask} >
                <Modal.Header closeButton>

                    <label>Pending Task</label>

                </Modal.Header>
                <Modal.Body >
                        <textarea rows={4} className="w-100" id="txtAreaTaskDone"></textarea>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseTask}>Close</Button>
                    <Button variant="danger" onClick={()=>updateTaskStatus(1)}>Save to History</Button>
                    <Button variant="primary" onClick={()=>updateTaskStatus(0)}>Task Done</Button>



                </Modal.Footer>
            </Modal>




        </Fragment>

    )
}
